import React, { FC } from 'react';
import { Box } from '@wix/design-system';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from '../../../ErrorFallback';
import { ReviewProps } from '@components/Reviews/types';
import Review from '@components/Reviews/Review';

export type ReviewsTextKeys = Record<
  'viewReviewSubjectCTA' | 'replyAuthorTitle' | 'noReviews',
  string
>;

const ReviewWrapper: FC<ReviewProps> = ({
  review,
  isMyProfile,
  services,
  handleBiGenericClick,
  i18nKeys,
  isMobileView,
  replyProps,
  onEdit,
  userReview,
  ReviewHeader,
  reviewStyles,
}) => {
  return (
    <Box
      display="block"
      padding="SP4"
      height="fit-content"
      border="1px solid #DFE5EB"
      borderRadius="8px"
    >
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Review
          i18nKeys={i18nKeys}
          review={review}
          isMyProfile={isMyProfile}
          services={services}
          handleBiGenericClick={handleBiGenericClick}
          isMobileView={isMobileView}
          replyProps={replyProps}
          onEdit={onEdit}
          userReview={userReview}
          ReviewHeader={ReviewHeader}
          reviewStyles={reviewStyles}
        />
      </ErrorBoundary>
    </Box>
  );
};

export default ReviewWrapper;
